import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
	jsonMapProperty,
} from '@sumbricht/json-class-serializer'
import { BoReference } from './bo-reference.js'

@jsonClass('ModuleImport')
export class ModuleImport extends BoReference {
	constructor(init?: Partial<ModuleImport>) {
		super()
		assignCommonProperties(this, init)
	}
}
